module.exports = __webpack_public_path__ + "5e67a96cd7bbbe439a23f8d967d52de5.pdf";